module.exports = __webpack_public_path__ + "img/b-0.af55032.png";